export default () => ({
    collectionName: Alpine.$persist('')
        .as('collection-collectionName')
        .using(sessionStorage),
    sortByOptions: [
        {
            value: 'manual',
            name: 'Most Relevant',
        },
        {
            value: 'created-descending',
            name: 'Most Recent',
        },
        {
            value: 'price-ascending',
            name: 'Price: Low to High',
        },
        {
            value: 'price-descending',
            name: 'Price: High to Low',
        },
    ],
    sortBy: shopifyData.collection.sortBy || 'manual',
    page:
        Alpine.$persist(shopifyData.pagination.page)
            .as('collection-page')
            .using(sessionStorage) || 1,
    loaded: false,
    loadMoreText: 'Load more',
    columnSize: Alpine.$persist(2)
        .as('collection-columnSize')
        .using(sessionStorage),

    init() {
        const searchParams = new URLSearchParams(location.search)

        if (this.collectionName !== shopifyData.collection.title) {
            this.collectionName = shopifyData.collection.title
            this.page = 1
        } else if (this.page > 1 && !searchParams.has('page')) {
            this.page = 1
        }

        this.$nextTick(async () => {
            if (this.page > 1) {
                let i = 1

                while (i < this.page) {
                    const skeletonProductCards = this.$root.querySelectorAll(
                        '[data-product-card-skeleton]'
                    )
                    const pageOfProducts = await this.fetchProducts(i)

                    const skeletonCardsToBeReplaced = Array.from(
                        skeletonProductCards
                    ).slice(0, pageOfProducts.length)

                    skeletonCardsToBeReplaced.forEach((skeletonCard, index) => {
                        skeletonCard.replaceWith(pageOfProducts[index])
                    })

                    i++
                }

                const url = this.updateUrlSearchParams([
                    { key: 'page', value: this.page },
                ])

                window.history.replaceState({}, '', url.href)
            }

            this.loaded = true
        })
    },

    sortProducts(e) {
        const newSortBy = e.target.value
        const url = this.updateUrlSearchParams([
            { key: 'sort_by', value: newSortBy },
        ])

        if (e.target.value !== this.sortBy) {
            this.page = 1
            url.searchParams.set('page', 1)
        }

        location.search = url.search
    },
    async fetchProducts(page) {
        if (typeof page === 'undefined' || typeof page !== 'number') {
            throw new Error('Page number is required and must be a number.')
        }

        const url = this.updateUrlSearchParams([{ key: 'page', value: page }])

        const response = await fetch(url.href)

        if (!response.ok) {
            throw new Error('Failed to fetch products.')
        }

        const html = await response.text()

        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        return Array.from(doc.querySelectorAll('[data-product-card]'))
    },
    async loadMore() {
        const defaultLoadMoreText = this.loadMoreText
        this.loadMoreText = 'Loading...'

        const productsGrid = this.$refs.productsGrid
        const products = await this.fetchProducts(this.page + 1)
        productsGrid.append(...products)

        this.page++

        const url = this.updateUrlSearchParams([
            { key: 'page', value: this.page },
        ])
        window.history.replaceState({}, '', url.href)

        this.loadMoreText = defaultLoadMoreText
    },
    updateUrlSearchParams(params = []) {
        const url = new URL(location.href)

        params.forEach((param) => {
            url.searchParams.set(param.key, param.value)
        })

        return url
    },
})
